/* eslint-disable @typescript-eslint/no-explicit-any */
interface IAppBridge {
  sendMessageToApp(method: string, data?: unknown): void;
  sendMessageToAppWithReturn(method: string, data: unknown): Promise<unknown>;
  sendMessageToAppWithParam(method: string, data?: unknown): void;
}

export const AppBridge: IAppBridge = {
  sendMessageToApp(method: string, data?: unknown): void {
    const message = { data };
    // iOS Communication
    if (window.webkit?.messageHandlers[method]) {
      console.log('IOS [Webview -> App]: ', { method, message });
      window.webkit.messageHandlers[method].postMessage(
        JSON.stringify(message)
      );
    }
    // Android Communication
    else if (window.Android && typeof window.Android[method] === 'function') {
      console.log('Android [Webview -> App]: ', { method, message });
      window.Android[method]();
    }
  },

  sendMessageToAppWithReturn(method: string, data: unknown): Promise<unknown> {
    return new Promise((resolve, reject) => {
      const message = { data };

      // iOS Communication
      if (window.webkit?.messageHandlers[method]) {
        window.webkit.messageHandlers[method].postMessage(
          JSON.stringify(message)
        );
        console.log('IOS [Webview -> App (with return)]: ', {
          method,
          message
        });
        // The native reply arrives by invoking this window global. If it never
        // does (native bug, backgrounded app), the caller used to hang forever
        // on a loader with no error and no Sentry event — bound it. 5s covers
        // the worst observed force-refresh leg on poor cellular.
        const timer = setTimeout(() => {
          delete (window as any)[`${method}Callback`];
          reject(new Error(`AppBridge: native reply for ${method} timed out`));
        }, 5000);
        (window as any)[`${method}Callback`] = (result: unknown) => {
          clearTimeout(timer);
          delete (window as any)[`${method}Callback`];
          resolve(result);
        };
      } else if (
        window.Android &&
        typeof window.Android[method] === 'function'
      ) {
        console.log('Android [Webview -> App (with return)]: ', {
          method,
          message
        });
        const result = window.Android[method](JSON.stringify(message));
        console.log(`Result from Android method ${method}:`, result);
        resolve(result);
      } else {
        reject(new Error('Method not available'));
      }
    });
  },

  sendMessageToAppWithParam(method: string, data?: unknown): void {
    const message = { data };
    // iOS Communication
    if (window.webkit?.messageHandlers[method]) {
      window.webkit.messageHandlers[method].postMessage(
        JSON.stringify(message)
      );
    }
    // Android Communication
    else if (window.Android && typeof window.Android[method] === 'function') {
      window.Android[method](JSON.stringify(message));
    }
  }
};

// // Global handlers need to be registered directly on window
// (window as any).receiveMessageFromAppMethodOne = (response: {
//   data: unknown;
// }) => {
//   console.log('Received from App (String):', response.data);
// };

// (window as any).receiveMessageFromAppMethodTwo = (response: {
//   data: boolean;
// }) => {
//   console.log('Received from App (Bool):', response.data);
// };

// (window as any).receiveMessageFromAppMethodThree = (response: {
//   data: Record<string, unknown>;
// }) => {
//   console.log('Received from App (Json):', response.data);
// };
